module.exports = __webpack_public_path__ + "3383a099ebd89f9d01f4927ceff8b845.png";